import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import BusinessCard from "@/components/BusinessCard";
import { useNavigate } from "react-router-dom";

export default function Favorites() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/giris"); return; }
    (async () => {
      const { data: favs } = await api.get("/favorites");
      const businesses = await Promise.all(favs.map((f) => api.get(`/businesses/${f.business_id}`).then((r) => r.data).catch(() => null)));
      setItems(businesses.filter(Boolean));
    })();
  }, [user, loading, nav]);

  return (
    <div className="mx-auto max-w-6xl px-4 py-6">
      <h1 className="text-2xl font-bold tracking-tight mb-4">Favorilerim</h1>
      {items.length === 0 && <p className="text-muted-foreground">Henüz favori eklemediniz.</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((b) => <BusinessCard key={b.id} business={b} />)}
      </div>
    </div>
  );
}
